import { render, staticRenderFns } from "./AuthDocumentUploader.vue?vue&type=template&id=f7ccf798&scoped=true&"
import script from "./AuthDocumentUploader.vue?vue&type=script&lang=js&"
export * from "./AuthDocumentUploader.vue?vue&type=script&lang=js&"
import style0 from "./AuthDocumentUploader.vue?vue&type=style&index=0&id=f7ccf798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ccf798",
  null
  
)

export default component.exports